/* ============================================================
   Fills — Artículo de blog. Tres mejoras progresivas (si falta el
   markup, cada una se salta sola):
     1) TOC automático desde los <h2> + scroll-spy (sidebar desktop).
     2) Clona el TOC en un <details> colapsable para mobile.
     3) Vuelve clicables las citas [n] del texto → su referencia.
   ============================================================ */
(function () {
  function slug(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  function buildTOC(root, prose) {
    var toc = root.querySelector('[data-toc]');
    var list = root.querySelector('[data-toc-list]');
    if (!toc || !list) return;

    var heads = Array.prototype.slice.call(prose.querySelectorAll('h2')).filter(function (h) { return !/referencias/i.test(h.textContent || ''); });
    if (heads.length < 2) return; // no vale la pena un TOC de 1

    var used = {};
    var links = heads.map(function (h) {
      var id = h.id || slug(h.textContent || 'seccion');
      if (used[id]) { id = id + '-' + (used[id] += 1); } else { used[id] = 1; }
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    toc.hidden = false;

    // Espejo mobile: clona la lista en un <details> colapsable.
    var listM = root.querySelector('[data-toc-list-m]');
    var tocM = root.querySelector('[data-toc-m]');
    if (listM && tocM) { listM.innerHTML = list.innerHTML; tocM.hidden = false; }

    // Scroll-spy: marca el enlace de la sección visible.
    if ('IntersectionObserver' in window) {
      var byId = {};
      links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            links.forEach(function (a) { a.classList.remove('is-active'); });
            var a = byId[e.target.id];
            if (a) a.classList.add('is-active');
          }
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      heads.forEach(function (h) { spy.observe(h); });
    }
  }

  function linkCitations(prose) {
    // Localiza la lista de referencias: .fills-refs ol, o el <ol> que
    // sigue a un encabezado "Referencias".
    var refsOl = prose.querySelector('.fills-refs ol');
    if (!refsOl) {
      var hs = prose.querySelectorAll('h2, h3');
      for (var i = 0; i < hs.length; i++) {
        if (/referencias/i.test(hs[i].textContent || '')) {
          var el = hs[i].nextElementSibling;
          while (el && el.tagName !== 'OL') { el = el.nextElementSibling; }
          if (el) { refsOl = el; break; }
        }
      }
    }
    if (!refsOl) return;

    var lis = refsOl.children;
    for (var n = 0; n < lis.length; n++) { if (!lis[n].id) lis[n].id = 'fills-ref-' + (n + 1); }

    Array.prototype.forEach.call(prose.querySelectorAll('sup'), function (sup) {
      if (sup.querySelector('a')) return; // ya enlazada
      var m = (sup.textContent || '').match(/\[(\d+)\]/);
      if (!m) return;
      var target = document.getElementById('fills-ref-' + m[1]);
      if (!target) return;
      var a = document.createElement('a');
      a.href = '#fills-ref-' + m[1];
      a.className = 'fills-cite';
      a.setAttribute('aria-label', 'Ir a la referencia ' + m[1]);
      a.textContent = sup.textContent;
      sup.textContent = '';
      sup.appendChild(a);
    });
  }

  function init() {
    var root = document.querySelector('[data-fills-article]');
    if (!root) return;
    var prose = root.querySelector('[data-prose]');
    if (!prose) return;
    buildTOC(root, prose);
    linkCitations(prose);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
